import { useContext, useEffect } from 'react';
import LanguageProvider from '@/contexts/language';
import useABFeatureFromLocalStorage from '@/hooks/user/useABFeatureFromLocalStorage';
import { FEATURE_KEY_CUSTOM_LANGUAGE } from '@/config/feature-toggles/config';
import CONFIG from '@/config/global';

const { enableMultiLanguageSupport: enableMultiLanguageSupportForEveryone } = CONFIG;

const useLanguageEnabled = () => {
  const { handleEnableMultiLanguageSupport } = useContext(LanguageProvider);

  const { isEnabled: enableMultiLanguageSupportFromLS } = useABFeatureFromLocalStorage({ featureKey: FEATURE_KEY_CUSTOM_LANGUAGE });
  const enableMultiLanguageSupport = enableMultiLanguageSupportForEveryone || enableMultiLanguageSupportFromLS;

  useEffect(() => {
    if (enableMultiLanguageSupport) {
      handleEnableMultiLanguageSupport();
    }
  }, [enableMultiLanguageSupport, handleEnableMultiLanguageSupport]);

  return { enableMultiLanguageSupport };
};
    
export default useLanguageEnabled;